import App from './App'
import AppContainer from './AppContainer'
import { BUYER_DIR, HOMEOWNER_DIR, MARKETS_DIR } from './App'

export { BUYER_DIR, HOMEOWNER_DIR, MARKETS_DIR }
export default AppContainer(App)
